import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { Contact } from '@/components/contact';
import { Features } from '@/components/features';
import { Footer } from '@/components/footer';
import { Hero } from '@/components/hero';
import { HowItWorks } from '@/components/how-it-works';
import { LivePreview } from '@/components/live-preview';
import { Nav } from '@/components/nav';
import { SectionDivider } from '@/components/persian-ornament';
import { Pricing } from '@/components/pricing';

function Reveal({ children }: { children: ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

function Divider({ variant = 'girih' }: { variant?: 'girih' | 'diamond' }) {
  return (
    <div className="mx-auto max-w-4xl px-6 py-10 md:py-14">
      <SectionDivider variant={variant} />
    </div>
  );
}

export function LandingPage() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Divider />
        <Reveal>
          <Features />
        </Reveal>
        <Divider variant="diamond" />
        <Reveal>
          <LivePreview />
        </Reveal>
        <Divider />
        <Reveal>
          <HowItWorks />
        </Reveal>
        <Divider variant="diamond" />
        <Reveal>
          <Pricing />
        </Reveal>
        <Divider />
        <Reveal>
          <Contact />
        </Reveal>
      </main>
      <Footer />
    </>
  );
}
